module.exports = "https://syscdn.233leyuan.com/fw/activemodal/1625144333412/static/img/bg-stone-2.6f44f6e4.png";